import React from 'react';
import { skills } from '../data';
import './Pack.css';

export default function Pack() {
  return (
    <section id="skills" className="section" data-scene="snoqualmie">
      <div className="panel">
        <div className="section-head">
          <h2 className="section-head__title">Pack list</h2>
          <p className="section-head__sub">What I work with.</p>
        </div>

        <div className="pack">
          {skills.map((group) => (
            <div className="pack__group" key={group.name}>
              <h3 className="pack__name">{group.name}</h3>
              <ul className="pack__list">
                {group.items.map((item) => <li key={item}>{item}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
